import type {
	TestimonialUmbBlockElementModel,
	TestimonialUmbBlockSettingsElementModel,
} from "#/_generated/umbraco/delivery-api/models";
import { Testimonial } from "#/_packages/umbrella/features/testimonial/components/testimonial";
import type { BlockItemProps } from "#/_packages/umbrella/integrations/umbraco/types";
import { getFocalPointUrl } from "#/_packages/umbrella/integrations/umbraco/utils/image-utils.ts";
import {
	tryGetAnimationScrollType,
	tryGetAspectRatio,
	tryGetBoxVariant,
	tryGetReadWidthLength,
} from "#/_packages/umbrella/utils";
import { getAltText } from "#/_packages/umbrella/utils/image-utils.ts";

interface ITestimonialBlockProps extends BlockItemProps {
	content: TestimonialUmbBlockElementModel;
	settings: TestimonialUmbBlockSettingsElementModel;
}

export default function TestimonialUmbBlock({
	className,
	content,
	settings,
}: ITestimonialBlockProps) {
	const contentProperties = content.properties;
	const settingsProperties = settings.properties;
	const image = contentProperties?.image?.[0];
	const aspectRatio = tryGetAspectRatio(contentProperties?.aspectRatio);

	return (
		<Testimonial
			id={settingsProperties?.generatedId ?? content.id}
			quote={contentProperties?.quote}
			source={contentProperties?.source}
			sourceDescription={contentProperties?.sourceDescription}
			image={
				image
					? {
							src: getFocalPointUrl(image, 160, aspectRatio),
							alt: getAltText(image),
						}
					: undefined
			}
			aspectRatio={aspectRatio}
			quotationMarks={contentProperties?.quotationMarks ?? false}
			boxVariant={tryGetBoxVariant(settingsProperties?.boxVariant)}
			fullHeight={settingsProperties?.fullHeight ?? false}
			readWidthToggle={settingsProperties?.readWidthToggle ?? false}
			readWidthLength={tryGetReadWidthLength(
				settingsProperties?.readWidthLengthPicker,
			)}
			animationHoverType={settingsProperties?.animationHoverType ?? []}
			animationScrollType={tryGetAnimationScrollType(
				settingsProperties?.animationScrollType,
			)}
			className={className}
		/>
	);
}
